import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

/**
 * options should be an array of objects with 'label' and 'value' keys
 * e.g. [ { label: 'Card Items', value: 'card_items' }, { label: 'Supply Usage', value: 'supply_usage' } ]
 */
function ToggleButtons({ options, toggleValue, setToggleValue, logUserAction = null, actionName='toggled_value', actionLocation='' }) {

    const handleToggleTab = (newValue) => {
        setToggleValue(newValue);
        logUserAction && logUserAction({ action: actionName, data: { tab: newValue, location: actionLocation } });
    };

    return (
        <ToggleButtonGroup
            variant="standard"
            exclusive
            value={toggleValue}
            onChange={(event, newValue) => {
                // prevent deselecting the current button: newValue will be null when user clicks the selected button
                if (newValue === null) return;
                handleToggleTab(newValue);
            }}
        >
            {options.map((option) => (
                <ToggleButton key={option.value} variant="standard" value={option.value}>
                    {option.label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    )
}

export default ToggleButtons;